export default __webpack_public_path__ + "static/media/b2.8f8726a1.png";